import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { SelectableSettings } from '@progress/kendo-angular-grid';
import { take } from 'rxjs/operators';
import { DestroyBase } from '../../../../components/common/ng-destroy-base';
import { LocalizationModel } from '../../models/localization-model';
import { LocalizationNavigationService } from '../../services/localization-navigation-service';
import { LocalizationService } from '../../services/localization-service';
import { AppLoadingIndicatorService } from '../../../../services/app-loading-indicator.service';

/**
 * Handles calculation model assign component
 */
@Component({
  selector: 'localization-grid',
  templateUrl: './localization-grid.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LocalizationGridComponent extends DestroyBase implements OnInit {
  /**
   * The grid data
   */
  public gridData: any[] = [];

  /**
   * Selected item
   */
  private selectedItem: LocalizationModel;

  /**
   * Clicked row item. Used for doubleclick detection
   */
  private clickedRowItem: any;

  /**
   * Save selected localization
   */
  selectedLocalization = [];

  /**
   * Grid SelectableSettings
   */
  public selectableSettings: SelectableSettings = {
    enabled: true,
    mode: 'single'
  };

  /**
   * Constructor
   * @param localizationService
   * @param localizationNavigationService
   * @param ref
   * @param appLoadingIndicator
   */
  constructor(private localizationService: LocalizationService,
    private localizationNavigationService: LocalizationNavigationService,
    private ref: ChangeDetectorRef,
    private appLoadingIndicator: AppLoadingIndicatorService) {
    super();
  }

  /**
   * Initializes the component
   */
  ngOnInit(): void {
    this.loadData();
  }

  /**
   * Loads the data
   */
  private loadData(): void {

    this.appLoadingIndicator.show();
    this.localizationService.getLocalizations().pipe(take(1)).subscribe(data => {
      this.gridData = data;
      this.appLoadingIndicator.hide();
      const activeLocalization = this.localizationNavigationService.getActiveLocalization();
      this.selectedLocalization = activeLocalization ? [activeLocalization.id] : [];
      this.ref.markForCheck();
    });
  }

  /**
   * On row selection
   * @param event
   */
  public onRowSelected(event: any): void {
    this.selectedItem = event.selectedRows.length > 0 ? event.selectedRows[0].dataItem : null;
    this.localizationNavigationService.onGridItemSelected(this.selectedItem);
  }

  /**
   * A cell was clicked. Remember the current row item for doubleclick detection
   * @param event
   */
  public cellClick(event: any): void {
    this.clickedRowItem = event.dataItem;
    this.localizationNavigationService.setActiveLocalization(event.dataItem);
  }

  /**
   * A ddoubleclick event was detected
   * @param event
   */
  public onDoubleClicked(): void {
    if (this.clickedRowItem) {
      this.localizationService.openForm(this.clickedRowItem.id);
      this.localizationNavigationService.displayAddEditIcons(false);
    }
  }
}
